import {createContext} from 'react';

const GraphCanvasContext = createContext();

export default GraphCanvasContext;
